import { Container, Nav, Navbar } from 'react-bootstrap';
import React from 'react';
import { NavLink } from './NavbarElements';
import "../assets/styles/navbar.css";
import { useTranslation } from 'react-i18next';

const NavbarComponent = () => {
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'it' ? 'en' : 'it';
    i18n.changeLanguage(newLang);
  };

  return (
    <>
      <Navbar className='navbar' bg="transparent">
        <Container className="d-flex justify-content-center align-items-center">
          <Nav>
            <NavLink to="/">{t('nav.home')}</NavLink>
            <NavLink to="/contatti">{t('nav.contatti')}</NavLink>
            <NavLink to="/gallery">{t('nav.galleria')}</NavLink>
          </Nav>
          <button
            className="lang-switch-btn"
            onClick={toggleLanguage}
            aria-label="Switch language"
          >
            {i18n.language === 'it' ? '🇬🇧 EN' : '🇮🇹 IT'}
          </button>
        </Container>
      </Navbar>
    </>
  );
};

export default NavbarComponent;